import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

export enum NavigationRoutes {
  Home = 'Home',
  Play = 'Play',
  Auth = 'Auth',
  Imprint = 'Imprint',
  Rules = 'Rules',
  Profile = 'Profile',
  Privacy = 'Privacy',
  NotFound = '404'
}

const routes = [
  {
    path: '/',
    name: NavigationRoutes.Home,
    component: () => import('./views/Home.vue'),
  },
  {
    path: '/spielen',
    name: NavigationRoutes.Play,
    component: () => import('./views/Play.vue'),
  },
  {
    path: '/anmelden',
    name: NavigationRoutes.Auth,
    component: () => import('./views/auth/Auth.vue')
  },
  {
    path: '/regeln',
    name: NavigationRoutes.Rules,
    component: () => import('./views/Rules.vue')
  },
  {
    path: '/impressum',
    name: NavigationRoutes.Imprint,
    component: () => import('./views/Imprint.vue')
  },
  {
    path: '/profil',
    name: NavigationRoutes.Profile,
    component: () => import('./views/Profile.vue'),
  },
  {
    path: '/datenschutz',
    name: NavigationRoutes.Privacy,
    component: () => import('./views/PrivacyPolicy.vue')
  },
  {
    path: '*',
    name: NavigationRoutes.NotFound,
    component: () => import('./views/404.vue')
  }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
